import React, { Component } from 'react';
import PilotlyPlayer from '../components/global/PilotlyPlayer';
import EnvironmentContainer from './EnvironmentContainer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { setTargetParams } from '../redux/actions/index';
import settings from "../libs/config";
import FadeIn from '../components/global/FadeIn';
import PageLoader from '../components/global/PageLoader';

import Logger from '../functions/logging';
import { isModerated } from '../functions/study';
import { setCookieValue } from "../functions/persistent";
import { getToken } from "../functions/auth";
import { initCap } from "../functions/utils";
import { setViewerCookies, getRedirectToReelChat } from '../functions/helpers';

class Study extends Component {
	static getDerivedStateFromProps(props, state) {
		Logger.log(Study.name, "getDerivedStateFromProps()", props);

		let { targetParams, fetchedGroup, fetchedEpisode, currentUser } = props;
		if (isModerated(targetParams, fetchedGroup)) {
			Logger.log(Study.name, "getDerivedStateFromProps() isModerated", targetParams, fetchedGroup);

			setViewerCookies(targetParams, fetchedGroup, fetchedEpisode, currentUser);
			let url = getRedirectToReelChat(targetParams, targetParams.ps); 

			Logger.log(Study.name, "getDerivedStateFromProps() isModerated url", url);
			window.location.replace(url);
		}
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);

		let { targetParams, fetchedGroup } = this.props;
		let studyComponent = "";

		if (isModerated(targetParams, fetchedGroup)) {
			studyComponent = <PageLoader loading={true} />;
		}
		else if (fetchedGroup) {
			switch (fetchedGroup.research_env) {
				case "svod": {
					studyComponent = <EnvironmentContainer {...this.props} />;
					break;
				}
				default: {
					studyComponent = <PilotlyPlayer {...this.props} />;
				}
			}
		}

		return (
			<FadeIn>
				<div className="pilotly-study">
					{studyComponent}
				</div>
			</FadeIn>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedEpisode: state.targetProcess.fetchedEpisode,
		fetchedGroup: state.targetProcess.fetchedGroup,
		fetchedPanel: state.targetProcess.fetchedPanel,
		targetParams: state.targetProcess.targetParams
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setTargetParams,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Study);


// WEBPACK FOOTER //
// ./src/pages/Study.js